import React from 'react';
import { SPLAT } from '../../../config/constants/images';

const AmenitiesPopularIcon = () => (
  <>
    <div className="svg-inline--fa fa-splat fa-w-18" />
    <style jsx>
      {`
        .fa-splat {
          background: url(${SPLAT[process.env.NEXT_PUBLIC_BRAND || 'wowcher']})
            no-repeat center;
          background-size: contain;
        }
      `}
    </style>
  </>
);

export default AmenitiesPopularIcon;
